module.exports = __webpack_public_path__ + "public/img/certificate.57409c30.jpeg";